import { rfqJobQuoteDetailsHeaderStyles } from "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsHeader";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

rfqJobQuoteDetailsHeaderStyles.headerGridContainer = {
    gap: 10,
    css: css`
    ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                padding-left : 15px;
                padding-right : 15px;
                `,
                css`
                padding-left : 15px;
                padding-right : 15px;
                `,
                null,
                null,
                null
            ]);
        }}
`
}

rfqJobQuoteDetailsHeaderStyles.title = {
    variant: "h2",
    css: css`
        margin: 0.5rem 0 1.5rem 0;
    `,
};

rfqJobQuoteDetailsHeaderStyles.buttonGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        justify-content: flex-start;
    `,
};

rfqJobQuoteDetailsHeaderStyles.titleGridItem = {
    width: [12, 12, 12, 12, 12],
};
rfqJobQuoteDetailsHeaderStyles.generateOrderButton = {
    css: css`
        margin-left: 0px;
    `,
};